

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);
if(document.getElementById('app_listMesFactures') != null){

    document.addEventListener('alpine:init', () => {

        Alpine.data('app_listMesFactures', (route, limit, delayOuvertureFacture) =>({
            invoices : [],
            upcomingInvoice : null,
            displayLinkMoreInvoice : false,
            displayAucuneFacture : false,
            showLoader : true,
            delayOuvertureFacture : 1,
            init(){
                if(typeof delayOuvertureFacture == 'number'){
                    this.delayOuvertureFacture = delayOuvertureFacture;
                }
                this.limit = limit;
                setTimeout(()=>{
                    this.get_invoices()
                }, this.delayOuvertureFacture)


            },
            get_invoices(){
                axios({
                    method: 'get',
                    url: route,
                }).then(response =>{
                    // à venir

                    this.showLoader = false;

                    if(this.limit && this.limit != -1){
                        if(response.data.invoices.length > this.limit){
                            response.data.invoices.pop();
                            this.displayLinkMoreInvoice = true;
                        }
                    }

                    for (let i = 0; i <  response.data.invoices.length; i++) {
                        response.data.invoices[i]['created_readable']= dayjs(response.data.invoices[i]['created']).format('DD MMM YYYY');
                        try {
                            response.data.invoices[i]['period_start_readable']= dayjs(response.data.invoices[i]['period_start']).format('DD MMM ');
                            response.data.invoices[i]['period_end_readable']= dayjs(response.data.invoices[i]['period_end']).format('DD MMM ');

                            if(response.data.invoices[i].invoice_customer_addresses_tracking_number){

                                if(window.validUrl.isUri(response.data.invoices[i].invoice_customer_addresses_tracking_number)){
                                    response.data.invoices[i].invoice_customer_addresses_tracking_number_url = response.data.invoices[i].invoice_customer_addresses_tracking_number;
                                }else{
                                    response.data.invoices[i].invoice_customer_addresses_tracking_number_url = null;
                                }
                            }
                        } catch (error) {

                        }



                    }
                    this.invoices =  response.data.invoices;

                    if(this.invoices.length == 0){
                        this.displayAucuneFacture = true;
                    }
                });
            },

        }))
    })

}

if(document.getElementById('app_listMesFacturesUpcoming') != null){

    document.addEventListener('alpine:init', () => {

        Alpine.data('app_listMesFacturesUpcoming', (route) =>({
            upcomingInvoice :  [],
            displayLinkMoreInvoice : false,
            displayAucuneFacture : false,
            showLoader : true,
            showArea : false,
            init(){
                this.get_upcoming_invoices()
            },
            get_upcoming_invoices(){
                if(this.showArea){
                    return;
                }
                this.showArea = true;
                axios({
                    method: 'get',
                    url: route,
                }).then(response =>{
                    // à venir


                    let _upcomingInvoice = response.data.upcomingInvoice;

                    if(_upcomingInvoice){
                        for (const accountId in _upcomingInvoice) {
                            const invoices = _upcomingInvoice[accountId];

                            for (const invoice of invoices) {
                                invoice.next_payment_attempt_readable = dayjs(invoice.next_payment_attempt * 1000).format('DD MMM YYYY')

                            }
                        }
                    }
                    if(_upcomingInvoice){

                        this.upcomingInvoice = _upcomingInvoice;
                    }


                    if(this.upcomingInvoice.length == 0){
                        this.displayAucuneFacture = true;
                    }

                    this.showLoader = false;
                });
            }

        }))
    })

}
